import { Component, OnDestroy, OnInit } from "@angular/core";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";

import { Router } from "../../../../../node_modules/@angular/router";
import { AccommodationService } from "../services/accommodation.service";
import { ConsultantDecisionService } from "../services/consultant-decision.service";
import { ParagraphsService } from "../services/paragraphs.service";
import { SpecialAuthCodesService } from "../services/specialauthcodes.service";

@Component({
  templateUrl: "./consultant-decision.component.html",
  styleUrls: ["./consultant-decision.component.css"]
})
export class ConsultantDecisionComponent implements OnInit, OnDestroy {
  public reqAccomms: any = [];
  public rawReqAccomms: any = [];
  public accommList: any = [];
  public displayReqAccomms: any = [];
  public displayApprovedAccoms: any = [];
  public approvedAccomms: any = [];
  public isLoading: boolean;
  public statusOption: any = [];
  public otherRow: any = [];
  public standardRow: any = [];
  public deleteMsg: string = "";
  public selectedModal: string = "";
  public selectedRowDetails: any;
  public accommodation: any;
  public date: any;
  public paragraphs: any;
  public specialAuthCodes: any;
  public popUpTitle: string = "";
  public reqAccommsError: string = "";
  public standardAccommError: string = "";
  public otherAccommsError: string = "";
  public deleteError: string = "";
  public popUpData: any;
  public reqStatuscode: any;
  public otherAccoms: any = [];
  public sendValue: any = [];
  public pageError: number = 0;
  public paragraphsDescrib: any = [];
  public displayParagraphs: any = [];
  public notApprovedStatusCodeId: string = "";
  public approvedStatusCodeId: string = "";
  public pendingStatusCodeId: string = "";
  public otherAccommsId: string = "";
  public rowSelected: any;
  public reviewDetailsList: any;
  public showConfirmation: boolean = false;
  public value: any;
  public accommTemp: any = [];
  public navigate: boolean;
  public showSaveMsg: any = "";
  constructor(
    public consultantDecisionService: ConsultantDecisionService,
    public router: Router,
    public accommodationService: AccommodationService,
    public paragraphsService: ParagraphsService,
    public specialAuthCodesService: SpecialAuthCodesService
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.value = {
      REVIEW_DETAIL_ID: sessionStorage.getItem("reviewDetailId"),
      REQUEST_ID: sessionStorage.getItem("requestId")
    };
    this.pageError = 0;
    this.displayReqAccomms = [];
    this.standardRow = [];
    this.otherRow = [];
    this.rawReqAccomms = [];
    this.reqAccomms = [];
    this.otherAccommsError = "";

    this.isLoading = true;
    this.statusOption = ["Please Select", "Approved", "Not Approved"];
    Observable.forkJoin(
      this.accommodationService.getAllAccommodation(),
      this.paragraphsService.getAllParagraphs(),
      this.specialAuthCodesService.getActiveSpecialAuthCodes(),
      this.consultantDecisionService.getAllStatusCode(),
      this.consultantDecisionService.getAllReqAccomms(this.value)
    )
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(
        ([
          accommodation,
          paragraphs,
          specialAuthCodes,
          reqStatusCode,
          reqAllAccomms
        ]) => {
          this.rawReqAccomms = reqAllAccomms;
          this.accommodation = accommodation;
          this.paragraphs = paragraphs;
          this.specialAuthCodes = specialAuthCodes;
          this.reqStatuscode = reqStatusCode;
          this.approvedAccomms = _.remove(this.rawReqAccomms, function (
            element
          ) {
            return element.RA_STATUS_CODE === "Approved";
          });

          this.accommList =this.rawReqAccomms;
          this.displayApprovedAccoms = [];
          this.approvedAccomms.forEach(element => {
            const data: any = {
              ACCOMM_VALUE: {
                ACCOMMODATION_DS: ""
              },
              STATUS_CD: "",
              OTHER_DS: "",
              AUTH_CODE: [],
              PARA: [],
              SELECTED_CODE: "",
              EXP_DATE: "",
              SAVED_EXP_DATE: "",
              REQUEST_STATUS_CODE_ID: "",
              REQUESTED_ACCOMMODATION_ID: "",
              CREATED_BY_USER_TYPE_CD: "",
              REVIEW_DETAIL_ACCOMM_STATUS_ID: ""
            };
            if (element.ACCOMMODATION_DS) {
              data.ACCOMM_VALUE.ACCOMMODATION_DS = element.ACCOMMODATION_DS;
            }
            if (element.OTHER_DS) {
              data.OTHER_DS = element.OTHER_DS;
            }
            if (element.EXPIRATION_DT) {
              data.SAVED_EXP_DATE = element.EXPIRATION_DT;
              data.EXP_DATE = moment(element.EXPIRATION_DT).format(
                "DD-MMM-YY hh.mm.ss.SSSSSSSSS a"
              );
            }
            data.REQUESTED_ACCOMMODATION_ID =
              element.REQUESTED_ACCOMMODATION_ID;
            data.CREATED_BY_USER_TYPE_CD = element.CREATED_BY_USER_TYPE_CD;
            data.STATUS_CD = element.RA_STATUS_CODE;
            data.REQUEST_STATUS_CODE_ID = element.REQUEST_STATUS_CODE_ID;

             // Check if the accommodation already exists in the displayApprovedAccoms array
              const isAccommAlreadyAdded = this.displayApprovedAccoms.some(
              (acc) => acc.ACCOMM_VALUE.ACCOMMODATION_DS === data.ACCOMM_VALUE.ACCOMMODATION_DS
           );

             // If not already added, push the new accommodation data
              if (!isAccommAlreadyAdded) {
              this.displayApprovedAccoms.push(data);
            }
            // this.displayApprovedAccoms.push(data);
          });

          this.accommList.forEach(ele => {
            let count = 0;
            const accommsId = ele.ACCOMMODATION_ID;
            for (let i = 0; i < this.rawReqAccomms.length; i++) {
              if (
                this.rawReqAccomms[i].ACCOMMODATION_ID === accommsId &&
                this.rawReqAccomms[i].REVIEW_DETAIL_ID ===
                this.value.REVIEW_DETAIL_ID
              ) {
                count++;
                this.reqAccomms.push(this.rawReqAccomms[i]);
              } else {
                if (i === this.rawReqAccomms.length - 1 && count === 0) {
                  const data: any = {
                    ACCOMMODATION_DS: "",
                    ACCOMMODATION_ID: "",
                    STATUS_CD: "Pending",
                    OTHER_DS: "",
                    SPECIAL_AUTH_CODE_ID: "",
                    CODE_NM: "",
                    SELECTED_CODE: "",
                    EXPIRATION_DT: "",
                    SAVED_EXP_DATE: "",
                    REQUEST_STATUS_CODE_ID: "",
                    REQUESTED_ACCOMMODATION_ID: "",
                    CREATED_BY_USER_TYPE_CD: "",
                    REVIEW_DETAIL_ACCOMM_STATUS_ID: "",
                    REVIEW_DETAIL_ID: "",
                    REQ_STATUS: "",
                    REQ_ACCOMM_DECISION_CODE_ID: ""
                  };
                  data.REQUESTED_ACCOMMODATION_ID =
                    ele.REQUESTED_ACCOMMODATION_ID;
                  data.CREATED_BY_USER_TYPE_CD = "REQUESTOR";
                  data.ACCOMMODATION_ID = accommsId;
                  data.ACCOMMODATION_DS = ele.ACCOMMODATION_DS;
                  data.OTHER_DS = ele.OTHER_DS;
                  data.REVIEW_DETAIL_ID = this.value.REVIEW_DETAIL_ID;
                  data.REQUEST_STATUS_CODE_ID = this.pendingStatusCodeId;
                  this.reqAccomms.push(data);
                }
              }
            }
          });
          this.buildPage();
        }
      );
  }
  ngOnDestroy() { }
  buildPage() {
    this.reqStatuscode.forEach(element => {
      if (element.STATUS_CD === "NotApproved") {
        this.notApprovedStatusCodeId = element.REQUEST_STATUS_CODE_ID;
      } else if (element.STATUS_CD === "Pending") {
        this.pendingStatusCodeId = element.REQUEST_STATUS_CODE_ID;
      } else if (element.STATUS_CD === "Approved") {
        this.approvedStatusCodeId = element.REQUEST_STATUS_CODE_ID;
      }
    });

    this.otherAccoms = _.remove(this.reqAccomms, function (element) {
      return (
        element.CREATED_BY_USER_TYPE_CD === "REQUESTOR" &&
        element.ACCOMMODATION_DS === "OTHER"
      );
    });

    this.reqAccomms.forEach(element => {
      const buildPara: any = {};
      const data: any = {
        ACCOMM_VALUE: {
          ACCOMMODATION_DS: ""
        },
        STATUS_CD: "",
        OTHER_DS: "",
        AUTH_CODE: [],
        PARA: [],
        SELECTED_CODE: "",
        EXP_DATE: "",
        SAVED_EXP_DATE: "",
        REQUEST_STATUS_CODE_ID: "",
        REQUESTED_ACCOMMODATION_ID: "",
        CREATED_BY_USER_TYPE_CD: "",
        REVIEW_DETAIL_ACCOMM_STATUS_ID: ""
      };
      data.REQUESTED_ACCOMMODATION_ID = element.REQUESTED_ACCOMMODATION_ID;
      data.CREATED_BY_USER_TYPE_CD = element.CREATED_BY_USER_TYPE_CD;
      if (element.REVIEW_DETAIL_ACCOMM_STATUS_ID) {
        data.REVIEW_DETAIL_ACCOMM_STATUS_ID =
          element.REVIEW_DETAIL_ACCOMM_STATUS_ID;
      }
      if (element.STATUS_CD === null || element.STATUS_CD === "Pending") {
        data.STATUS_CD = "Please Select";
        data.REQUEST_STATUS_CODE_ID = this.pendingStatusCodeId;
      } else if (element.STATUS_CD === "NotApproved") {
        data.STATUS_CD = "Not Approved";
        data.REQUEST_STATUS_CODE_ID = this.notApprovedStatusCodeId;
      } else if (element.STATUS_CD === "Approved") {
        data.STATUS_CD = "Approved";
        data.REQUEST_STATUS_CODE_ID = this.approvedStatusCodeId;
      }
      if (element.ACCOMMODATION_DS) {
        data.ACCOMM_VALUE.ACCOMMODATION_DS = element.ACCOMMODATION_DS;
      }
      if (element.PARAGRAPH_ID) {
        buildPara.PARAGRAPH_ID = element.PARAGRAPH_ID;
        data.PARA.push({ PARAGRAPH_ID: element.PARAGRAPH_ID });
      }
      if (element.PARAGRAPH_NM) {
        buildPara.PARAGRAPH_NM = element.PARAGRAPH_NM;
        data.SELECTED_CODE = element.PARAGRAPH_NM;
      }

      if (element.PARAGRAPH_TX) {
        buildPara.PARAGRAPH_TX = element.PARAGRAPH_TX;
        this.paragraphsDescrib.push(buildPara);
      }
      if (element.SPECIAL_AUTH_CODE_ID) {
        data.AUTH_CODE.push({
          SPECIAL_AUTH_CODE_ID: element.SPECIAL_AUTH_CODE_ID
        });
      }
      if (element.CODE_NM) {
        data.SELECTED_CODE = element.CODE_NM;
      }

      if (element.OTHER_DS) {
        data.OTHER_DS = element.OTHER_DS;
      }
      if (element.EXPIRATION_DT) {
        data.SAVED_EXP_DATE = element.EXPIRATION_DT;
        data.EXP_DATE = moment(element.EXPIRATION_DT).format("MM/DD/YYYY");
      }

      if (this.displayReqAccomms.length === 0) {
        this.displayReqAccomms.push(data);
      } else {
        for (let i = 0; i < this.displayReqAccomms.length; i++) {
          if (
            this.displayReqAccomms[i].ACCOMM_VALUE.ACCOMMODATION_DS ===
            data.ACCOMM_VALUE.ACCOMMODATION_DS &&
            data.REVIEW_DETAIL_ACCOMM_STATUS_ID ===
            this.displayReqAccomms[i].REVIEW_DETAIL_ACCOMM_STATUS_ID
          ) {
            if (
              !this.displayReqAccomms[i].SELECTED_CODE.includes(
                data.SELECTED_CODE
              )
            ) {
              this.displayReqAccomms[i].SELECTED_CODE =
                this.displayReqAccomms[i].SELECTED_CODE +
                "," +
                data.SELECTED_CODE;
            }

            if (data.PARA[0]) {
              this.displayReqAccomms[i].PARA.push(data.PARA[0]);
            } else if (data.AUTH_CODE[0]) {
              this.displayReqAccomms[i].AUTH_CODE.push(data.AUTH_CODE[0]);
            }
            break;
          } else {
            if (i === this.displayReqAccomms.length - 1) {
              this.displayReqAccomms.push(data);
            }
          }
        }
      }
    });
    this.otherAccoms.forEach(element => {
      if (element.REQ_STATUS === "P") {
        element.OTHER_DS = "Previous Other: " + element.OTHER_DS;
      }
    });
    this.paragraphs.forEach(element => {
      element.isSelected = false;
    });
    this.specialAuthCodes.forEach(element => {
      element.isSelected = false;
    });
    this.accommodation.forEach(element => {
      if (element.ACCOMMODATION_DS === "OTHER") {
        this.otherAccommsId = element.ACCOMMODATION_ID;
      }
    });
    this.displayReqAccomms.forEach(element => {
      if (element.AUTH_CODE.length > 0) {
        element.AUTH_CODE = _.uniqBy(element.AUTH_CODE, "SPECIAL_AUTH_CODE_ID");
      }
      if (element.PARA.length > 0) {
        element.PARA = _.uniqBy(element.PARA, "PARAGRAPH_ID");
      }
    });
    this.displayParagraphs = _.uniqBy(this.paragraphsDescrib, "PARAGRAPH_ID");
  }
  addOtherRow() {
    this.deleteError = "";
    const data = {
      ACCOMM_VALUE: {},
      OTHER_DS: "",
      STATUS_CD: "Please Select",
      AUTH_CODE: [],
      PARA: [],
      SELECTED_CODE: "",
      EXP_DATE: "",
      REQUEST_STATUS_CODE_ID: "",
      ACCOMMODATION_ID: this.otherAccommsId,
      PENDING_STATUS: this.pendingStatusCodeId
    };
    this.otherRow.push(data);
  }
  addStandardRow() {
    this.deleteError = "";
    const data = {
      ACCOMM_VALUE: "Please Select",
      STATUS_CD: "Please Select",
      OTHER_DS: "",
      AUTH_CODE: [],
      PARA: [],
      SELECTED_CODE: "",
      EXP_DATE: "",
      REQUEST_STATUS_CODE_ID: "",
      PENDING_STATUS: this.pendingStatusCodeId
    };
    this.standardRow.push(data);
  }
  selectedItem(event, data) {
    if (event.target.checked === true) {
      data.isSelected = true;
    } else {
      data.isSelected = false;
    }
  }

  selectedStatus(event, data) {
    this.deleteError = "";
    this.rowSelected = data;
    if (this.rowSelected.STATUS_CD === "Approved") {
      this.rowSelected.SELECTED_CODE = "";
      this.resetPara(data);
    } else if (this.rowSelected.STATUS_CD === "Not Approved") {
      this.rowSelected.EXP_DATE = "";
      this.rowSelected.SELECTED_CODE = "";
      this.rowSelected.AUTH_CODE = [];
    } else if (this.rowSelected.STATUS_CD === "Please Select") {
      this.rowSelected.SELECTED_CODE = "";
      this.resetPara(data);
      this.rowSelected.AUTH_CODE = [];
    }
  }

  addAuthcode(item) {
    this.rowSelected.SELECTED_CODE = "";
    this.rowSelected.AUTH_CODE = [];
    item.forEach(element => {
      if (element && element.isSelected === true) {
        if (this.rowSelected.id === "authCode") {
          this.rowSelected.SELECTED_CODE =
            this.rowSelected.SELECTED_CODE + element.CODE_NM + ", ";
          this.rowSelected.AUTH_CODE.push(element);
        }
      }
    });
    const remove = this.rowSelected.SELECTED_CODE.lastIndexOf(",");
    this.rowSelected.SELECTED_CODE = this.rowSelected.SELECTED_CODE.substring(
      0,
      remove
    );
    this.onCloseHandled("addPopModal");
  }
  addPara(item) {
    this.resetPara(this.rowSelected);
    this.rowSelected.PARA = [];
    this.rowSelected.EXP_DATE = "";
    this.rowSelected.SELECTED_CODE = "";
    item.forEach(element => {
      if (element && element.isSelected === true) {
        if (this.rowSelected.id === "para") {
          this.paragraphsDescrib.push(element);
          this.rowSelected.SELECTED_CODE =
            this.rowSelected.SELECTED_CODE + element.PARAGRAPH_NM + ", ";
          this.rowSelected.PARA.push(element);
        }
      }
    });
    this.popUpData = item;
    const remove = this.rowSelected.SELECTED_CODE.lastIndexOf(",");
    this.rowSelected.SELECTED_CODE = this.rowSelected.SELECTED_CODE.substring(
      0,
      remove
    );
    this.displayParagraphs = _.uniqBy(this.paragraphsDescrib, "PARAGRAPH_ID");

    this.onCloseHandled("addPopModal");
  }

  save(id) {
    this.otherAccommsError = "";
    let count = 0;
    this.pageError = 0;
    this.navigate = id;
    this.showSaveMsg = "";
    this.displayReqAccomms.forEach((item, index, object) => {
      if (item.EXP_DATE) {
        const currentdate: any = new Date();
        if (Date.parse(item.EXP_DATE) < Date.parse(currentdate)) {
          this.pageError = this.pageError + 1;
          this.reqAccommsError = "Please select a valid Expiration Date";
          count = count + 1;
        } else {
          item.EXP_DATE = moment(item.EXP_DATE).format("MM/DD/YYYY");
          if (item.EXP_DATE === "Invalid date") {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
          }
        }
      }
      if (item.STATUS_CD === "Not Approved") {
        item.EXP_DATE = "";
      }
      if (item.STATUS_CD === "Please Select") {
        object.splice(index, 1);
      }
    });
    for (let i = 0; i < this.standardRow.length; i++) {
      for (let j = i + 1; j < this.standardRow.length; j++) {
        if (
          this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS ===
          this.standardRow[j].ACCOMM_VALUE.ACCOMMODATION_DS
        ) {
          this.pageError = 1;
          this.reqAccommsError =
            "Duplicate entry: Accommodation already requested for -" +
            this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS;
          break;
        }
      }
    }
    if (this.pageError === 0) {
      this.standardRow.forEach((item, index, object) => {
        for (let j = 0; j < this.displayReqAccomms.length; j++) {
          if (
            this.displayReqAccomms[j].ACCOMM_VALUE.ACCOMMODATION_DS ===
            item.ACCOMM_VALUE.ACCOMMODATION_DS
          ) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError =
              "Duplicate entry: Accommodation already requested for -" +
              item.ACCOMM_VALUE.ACCOMMODATION_DS;
            break;
          }
        }
        for (let j = 0; j < this.displayApprovedAccoms.length; j++) {
          if (
            this.displayApprovedAccoms[j].ACCOMM_VALUE.ACCOMMODATION_DS ===
            item.ACCOMM_VALUE.ACCOMMODATION_DS
          ) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError =
              "Duplicate entry: Accommodation already requested for -" +
              item.ACCOMM_VALUE.ACCOMMODATION_DS;
            break;
          }
        }
        if (this.pageError === 0) {
          if (item.STATUS_CD === "Not Approved") {
            item.EXP_DATE = "";
          }
          if (item.STATUS_CD === "Please Select") {
            object.splice(index, 1);
          }
          if (item.EXP_DATE) {
            const currentdate: any = new Date();
            if (Date.parse(item.EXP_DATE) < Date.parse(currentdate)) {
              this.pageError = this.pageError + 1;
              this.reqAccommsError = "Please select a valid Expiration Date";
              count = count + 1;
            } else {
              item.EXP_DATE = moment(item.EXP_DATE).format("MM/DD/YYYY");
              if (item.EXP_DATE === "Invalid date") {
                this.pageError = this.pageError + 1;
                this.reqAccommsError = "Please select a valid Expiration Date";
                count = count + 1;
              }
            }
          }
        }
      });
      this.otherRow.forEach((item, index, object) => {
        if (item.OTHER_DS === "") {
          this.otherAccommsError = " Please select a accommodation name.";
          this.pageError = this.pageError + 1;
        }
        if (this.pageError === 0) {
          if (item.STATUS_CD === "Not Approved") {
            item.EXP_DATE = "";
          }
          if (item.STATUS_CD === "Please Select") {
            object.splice(index, 1);
          }
          if (item.EXP_DATE) {
            const currentdate: any = new Date();
            if (Date.parse(item.EXP_DATE) < Date.parse(currentdate)) {
              this.pageError = this.pageError + 1;
              this.reqAccommsError = "Please select a valid Expiration Date";
              count = count + 1;
            } else {
              item.EXP_DATE = moment(item.EXP_DATE).format("MM/DD/YYYY");
              if (item.EXP_DATE === "Invalid date") {
                this.pageError = this.pageError + 1;
                this.reqAccommsError = "Please select a valid Expiration Date";
                count = count + 1;
              }
            }
          }
        }
      });
      if (this.pageError === 0 && count === 0) {
        this.deleteBeforeSave();
      } else {
        if (count > 0) {
          this.reqAccommsError = "Please select a valid Expiration Date";
        }
      }
    }
  }
  deleteBeforeSave() {
    if (this.displayReqAccomms.length > 0) {
      for (let v = 0; v < this.displayReqAccomms.length; v++) {
        if (this.displayReqAccomms[v].REVIEW_DETAIL_ACCOMM_STATUS_ID !== "") {
          Observable.forkJoin(
            this.consultantDecisionService.deleteReqAccommForUpdate(
              this.displayReqAccomms[v].REVIEW_DETAIL_ACCOMM_STATUS_ID
            )
          ).subscribe(
            ([response]) => {
              if (response) {
                if (response && v === this.displayReqAccomms.length - 1) {
                  this.updateReqAccomms();
                }
              }
            },
            error => {
              console.log(error);
            }
          );
        } else {
          if (v === this.displayReqAccomms.length - 1) {
            this.updateReqAccomms();
          }
        }
      }
    } else {
      this.updateReqAccomms();
    }
  }
  submitResult() {
    if (this.pageError === 0) {
      this.deleteBeforeSave();
    }
  }
  updateReqAccomms() {
    if (this.displayReqAccomms.length > 0) {
      for (let v = 0; v < this.displayReqAccomms.length; v++) {
        this.displayReqAccomms[
          v
        ].REVIEW_DETAIL_ID = this.value.REVIEW_DETAIL_ID;
        this.displayReqAccomms[v].REQUEST_ID = this.value.REQUEST_ID;
        if (this.displayReqAccomms[v].STATUS_CD === "Approved") {
          this.displayReqAccomms[
            v
          ].REQUEST_STATUS_CODE_ID = this.approvedStatusCodeId;
        } else if (this.displayReqAccomms[v].STATUS_CD === "Not Approved") {
          this.displayReqAccomms[
            v
          ].REQUEST_STATUS_CODE_ID = this.notApprovedStatusCodeId;
          this.displayReqAccomms[v].EXP_DATE = "";
        }
        if (this.displayReqAccomms[v].REVIEW_DETAIL_ACCOMM_STATUS_ID !== "") {
          Observable.forkJoin(
            this.consultantDecisionService.reqSubmit(this.displayReqAccomms[v])
          ).subscribe(
            ([updatedReqAccomm]) => {
              this.updateReqAccommsPostSubscribe(updatedReqAccomm, v);
            },
            error => {
              console.log(error);
            }
          );
        } else {
          Observable.forkJoin(
            this.consultantDecisionService.reviewAccommSubmit(
              this.displayReqAccomms[v]
            )
          ).subscribe(
            ([updatedReqAccomm]) => {
              this.updateReqAccommsPostSubscribe(updatedReqAccomm, v);
            },
            error => {
              console.log(error);
            }
          );
        }
      }
    } else {
      this.sendValue = this.displayReqAccomms;
      this.saveStandardRow();
    }
  }

  updateReqAccommsPostSubscribe(updatedReqAccomm: any, v: number) {
    if (updatedReqAccomm && v === this.displayReqAccomms.length - 1) {
      this.sendValue = this.displayReqAccomms;
      this.saveStandardRow();
    }
  }
  saveStandardRow() {
    const reviewDetailId = this.value.REVIEW_DETAIL_ID;
    if (this.standardRow.length > 0) {
      for (let i = 0; i < this.standardRow.length; i++) {
        this.standardRow[i].REVIEW_DETAIL_ID = reviewDetailId;
        this.standardRow[i].REQUEST_ID = this.value.REQUEST_ID;
        if (this.standardRow[i].STATUS_CD === "Approved") {
          this.standardRow[
            i
          ].REQUEST_STATUS_CODE_ID = this.approvedStatusCodeId;
        } else if (this.standardRow[i].STATUS_CD === "Not Approved") {
          this.standardRow[
            i
          ].REQUEST_STATUS_CODE_ID = this.notApprovedStatusCodeId;
        }

        Observable.forkJoin(
          this.consultantDecisionService.submit(this.standardRow[i])
        ).subscribe(
          ([standardRow]) => {
            if (standardRow && i === this.standardRow.length - 1) {
              this.sendValue = this.sendValue.concat(this.standardRow);
              this.saveOtherRow();
            }
          },
          error => {
            console.log(error);
          }
        );
      }
    } else {
      this.sendValue = this.sendValue.concat(this.standardRow);
      this.saveOtherRow();
    }
  }
  saveOtherRow() {
    const reviewDetailId = this.value.REVIEW_DETAIL_ID;
    if (this.otherRow.length > 0) {
      for (let i = 0; i < this.otherRow.length; i++) {
        this.otherRow[i].ACCOMM_VALUE.ACCOMMODATION_DS = "OTHER";
        this.otherRow[i].REVIEW_DETAIL_ID = reviewDetailId;
        this.otherRow[i].REQUEST_ID = this.value.REQUEST_ID;
        if (this.otherRow[i].STATUS_CD === "Approved") {
          this.otherRow[i].REQUEST_STATUS_CODE_ID = this.approvedStatusCodeId;
        } else if (this.otherRow[i].STATUS_CD === "Not Approved") {
          this.otherRow[
            i
          ].REQUEST_STATUS_CODE_ID = this.notApprovedStatusCodeId;
        }

        Observable.forkJoin(
          this.consultantDecisionService.submit(this.otherRow[i])
        ).subscribe(
          ([otherRow]) => {
            if (otherRow && i === this.otherRow.length - 1) {
              this.sendValue = this.sendValue.concat(this.otherRow);
              this.consultantDecisionService.setReviewData({
                reqAccomms: this.sendValue,
                paragraph: this.displayParagraphs,
                approvedAccomms: this.displayApprovedAccoms
              });
              if (this.navigate === true) {
                this.router.navigate(["/consultantReviewDecision"]);
              } else {
                this.ngOnInit();
                this.reqAccommsError = "";
                this.showSaveMsg = "All your changes have been saved.";
              }
            }
          },
          error => {
            console.log(error);
          }
        );
      }
    } else {
      this.sendValue = this.sendValue.concat(this.otherRow);
      this.consultantDecisionService.setReviewData({
        reqAccomms: this.sendValue,
        paragraph: this.displayParagraphs,
        approvedAccomms: this.displayApprovedAccoms
      });
      if (this.navigate === true) {
        this.router.navigate(["/consultantReviewDecision"]);
      } else {
        this.ngOnInit();
        this.reqAccommsError = "";
        this.showSaveMsg = "All your changes have been saved.";
      }
    }
  }
  checkError(id, navigate) {
    this.showSaveMsg = "";
    this.navigate = navigate;
    this.showConfirmation = false;
    this.deleteError = "";
    this.pageError = 0;
    this.reqAccommsError = "";
    let count = 0;
    if (this.displayReqAccomms.length > 0) {
      for (let i = 0; i < this.displayReqAccomms.length; i++) {
        if (this.displayReqAccomms[i].STATUS_CD === "Please Select") {
          this.reqAccommsError =
            "Please select a decision for each accommodation.";
          this.pageError = this.pageError + 1;
          break;
        } else if (
          this.displayReqAccomms[i].STATUS_CD === "Not Approved" &&
          this.displayReqAccomms[i].PARA.length < 1
        ) {
          this.reqAccommsError = "Please select corresponding paragraph.";
          this.pageError = this.pageError + 1;
          break;
        }

        if (this.displayReqAccomms[i].EXP_DATE) {
          const currentdate: any = new Date();
          if (
            Date.parse(this.displayReqAccomms[i].EXP_DATE) <
            Date.parse(currentdate)
          ) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
            break;
          }
          this.displayReqAccomms[i].EXP_DATE = moment(
            this.displayReqAccomms[i].EXP_DATE
          ).format("MM/DD/YYYY");
          if (this.displayReqAccomms[i].EXP_DATE === "Invalid date") {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
            break;
          }
          this.showConfirmation = true;
        }
      }
    }
    for (let i = 0; i < this.standardRow.length; i++) {
      for (let j = i + 1; j < this.standardRow.length; j++) {
        if (
          this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS ===
          this.standardRow[j].ACCOMM_VALUE.ACCOMMODATION_DS
        ) {
          this.pageError = 1;
          this.reqAccommsError =
            "Duplicate entry: Accommodation already requested for -" +
            this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS;
          break;
        }
      }
    }
    if (this.pageError === 0 && this.standardRow.length > 0) {
      for (let i = 0; i < this.standardRow.length; i++) {
        if (this.standardRow.ACCOMM_VALUE === "Please Select") {
          this.standardAccommError =
            "Please select a Accommodation type for an accommodation.";
          this.pageError = this.pageError + 1;
          break;
        }
        if (this.standardRow[i].STATUS_CD === "Please Select") {
          this.standardAccommError =
            "Please select a decision for each accommodation.";
          this.pageError = this.pageError + 1;
          break;
        } else if (
          this.standardRow[i].STATUS_CD === "Not Approved" &&
          this.standardRow[i].PARA.length < 1
        ) {
          this.standardAccommError = "Please select corresponding paragraph.";
          this.pageError = this.pageError + 1;
          break;
        }

        for (let j = 0; j < this.displayReqAccomms.length; j++) {
          if (
            this.displayReqAccomms[j].ACCOMM_VALUE.ACCOMMODATION_DS ===
            this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS
          ) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError =
              "Duplicate entry: Accommodation already requested for -" +
              this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS;
            break;
          }
        }
        for (let j = 0; j < this.displayApprovedAccoms.length; j++) {
          if (
            this.displayApprovedAccoms[j].ACCOMM_VALUE.ACCOMMODATION_DS ===
            this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS
          ) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError =
              "Duplicate entry: Accommodation already requested for -" +
              this.standardRow[i].ACCOMM_VALUE.ACCOMMODATION_DS;
            break;
          }
        }

        if (this.standardRow[i].EXP_DATE) {
          const currentdate: any = new Date();
          if (
            Date.parse(this.standardRow[i].EXP_DATE) < Date.parse(currentdate)
          ) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
            break;
          }
          this.standardRow[i].EXP_DATE = moment(
            this.standardRow[i].EXP_DATE
          ).format("MM/DD/YYYY");
          if (this.standardRow[i].EXP_DATE === "Invalid date") {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
            break;
          }
          this.showConfirmation = true;
        }
      }
    }
    if (this.pageError === 0 && this.otherRow.length > 0) {
      for (let i = 0; i < this.otherRow.length; i++) {
        if (this.otherRow[i].OTHER_DS === "") {
          this.otherAccommsError = " Please select a accommodation name.";
          this.pageError = this.pageError + 1;
          break;
        } else if (
          this.otherRow[i].STATUS_CD === "Not Approved" &&
          this.otherRow[i].PARA.length < 1
        ) {
          this.otherAccommsError = "Please select corresponding paragraph.";
          this.pageError = this.pageError + 1;
          break;
        } else if (this.otherRow[i].STATUS_CD === "Please Select") {
          this.otherAccommsError =
            "Please select a decision for each accommodation.";
          this.pageError = this.pageError + 1;
          break;
        }

        if (this.otherRow[i].EXP_DATE) {
          const currentdate: any = new Date();
          if (Date.parse(this.otherRow[i].EXP_DATE) < Date.parse(currentdate)) {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
            break;
          }
          this.otherRow[i].EXP_DATE = moment(this.otherRow[i].EXP_DATE).format(
            "MM/DD/YYYY"
          );
          if (this.otherRow[i].EXP_DATE === "Invalid date") {
            this.pageError = this.pageError + 1;
            this.reqAccommsError = "Please select a valid Expiration Date";
            count = count + 1;
            break;
          }
          this.showConfirmation = true;
        }
      }
    }
    if (this.pageError === 0 && count === 0) {
      if (this.showConfirmation) {
        document.getElementById(id).style.display = "block";
      } else {
        this.submitResult();
      }
    }
  }
  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
  }

  openDeleteModal(id, data) {
    if (id === "newOther") {
      this.selectedModal = id;
      this.selectedRowDetails = data;
      this.deleteMsg =
        "This will delete the new other Requested Accommodaton/or Supports. Are you sure?";
    } else if (id === "other") {
      this.selectedModal = id;
      this.selectedRowDetails = data;
      this.deleteMsg =
        "This will delete the other Requested Accommodaton/or Supports. Are you sure?";
    } else if (id === "newStandard") {
      this.selectedModal = id;
      this.selectedRowDetails = data;
      this.deleteMsg =
        "This will delete the new Standard Requested Accommodaton/or Supports. Are you sure?";
    } else if (id === "standard") {
      this.selectedModal = id;
      this.selectedRowDetails = data;
      this.deleteMsg =
        "This will delete the Standard Requested Accommodaton/or Supports. Are you sure?";
    } else if (id === "approved") {
      this.selectedModal = id;
      this.selectedRowDetails = data;
      this.deleteMsg =
        "This will delete the Approved Requested Accommodaton/or Supports. Are you sure?";
    }

    document.getElementById("deleteModal").style.display = "block";
  }

  deleteRow() {
    this.deleteError = "";
    if (this.selectedModal === "newOther") {
      this.resetPara(this.selectedRowDetails);
      this.otherRow.splice(this.otherRow.indexOf(this.selectedRowDetails), 1);
    } else if (this.selectedModal === "newStandard") {
      this.resetPara(this.selectedRowDetails);
      this.standardRow.splice(
        this.standardRow.indexOf(this.selectedRowDetails),
        1
      );
    } else if (this.selectedModal === "standard") {
      this.consultantDecisionService
        .deleteReqAccomms(this.selectedRowDetails.REQUESTED_ACCOMMODATION_ID)
        .subscribe(response => {
          const result: any = response;
          if (
            result.body.status ===
            "Deleted Requested Accommodation Successfully"
          ) {
            this.resetPara(this.selectedRowDetails);
            for (let i = 0; i < this.displayReqAccomms.length; i++) {
              if (
                this.displayReqAccomms[i].REQUESTED_ACCOMMODATION_ID ===
                this.selectedRowDetails.REQUESTED_ACCOMMODATION_ID
              ) {
                this.displayReqAccomms.splice(i, 1);
                break;
              }
            }
          } else {
            this.deleteError =
              "Deleting Apparoved Requested Accommodation Failed";
          }
        });
    } else if (this.selectedModal === "approved") {
      this.consultantDecisionService
        .deleteReqAccomms(this.selectedRowDetails.REQUESTED_ACCOMMODATION_ID)
        .subscribe(response => {
          const result: any = response;
          if (
            result.body.status ===
            "Deleted Requested Accommodation Successfully"
          ) {
            for (let i = 0; i < this.approvedAccomms.length; i++) {
              if (
                this.approvedAccomms[i].REQUESTED_ACCOMMODATION_ID ===
                this.selectedRowDetails.REQUESTED_ACCOMMODATION_ID
              ) {
                this.approvedAccomms.splice(i, 1);
                break;
              }
            }
            for (let i = 0; i < this.displayApprovedAccoms.length; i++) {
              if (
                this.displayApprovedAccoms[i].REQUESTED_ACCOMMODATION_ID ===
                this.selectedRowDetails.REQUESTED_ACCOMMODATION_ID
              ) {
                this.displayApprovedAccoms.splice(i, 1);
                break;
              }
            }
          } else {
            this.deleteError =
              "Deleting Standard Requested Accommodation Failed";
          }
        });
    }
    this.onCloseHandled("deleteModal");
  }

  openPopup(id, data) {
    this.deleteError = "";
    this.rowSelected = data;
    this.rowSelected.id = id;
    if (id === "para") {
      this.selectedModal = id;
      this.popUpTitle = "Paragraphs";
      this.paragraphs.forEach(element => {
        element.isSelected = false;
      });
      if (this.rowSelected.PARA) {
        for (let j = 0; j < this.rowSelected.PARA.length; j++) {
          for (let i = 0; i < this.paragraphs.length; i++) {
            if (
              this.rowSelected.PARA[j].PARAGRAPH_ID ===
              this.paragraphs[i].PARAGRAPH_ID
            ) {
              this.paragraphs[i].isSelected = true;
              break;
            }
          }
        }
      }
      this.popUpData = this.paragraphs;
    } else if (id === "authCode") {
      this.selectedModal = id;
      this.popUpTitle = "Special Authorization Codes";
      this.specialAuthCodes.forEach(element => {
        element.isSelected = false;
      });
      if (this.rowSelected.AUTH_CODE) {
        for (let j = 0; j < this.rowSelected.AUTH_CODE.length; j++) {
          for (let i = 0; i < this.specialAuthCodes.length; i++) {
            if (
              this.rowSelected.AUTH_CODE[j].SPECIAL_AUTH_CODE_ID ===
              this.specialAuthCodes[i].SPECIAL_AUTH_CODE_ID
            ) {
              this.specialAuthCodes[i].isSelected = true;
              break;
            }
          }
        }
      }
      this.popUpData = this.specialAuthCodes;
    }
    document.getElementById("addPopModal").style.display = "block";
  }
  resetPara(data) {
    this.rowSelected = data;
    for (let j = 0; j < this.rowSelected.PARA.length; j++) {
      for (let i = 0; i < this.paragraphsDescrib.length; i++) {
        if (
          this.rowSelected.PARA[j].PARAGRAPH_ID ===
          this.paragraphsDescrib[i].PARAGRAPH_ID
        ) {
          this.paragraphsDescrib.splice(i, 1);
          break;
        }
      }
    }
    this.rowSelected.PARA = [];
    this.displayParagraphs = _.uniqBy(this.paragraphsDescrib, "PARAGRAPH_ID");
  }

  toBack() {
    this.router.navigate(["accommsSupport"]);
  }
  openModal() {
    document.getElementById("previewModal").style.display = "block";
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/consultant-decision/consultant-decision.component.ts